// @flow

import { i18n } from 'shared/utils';
import type { FilterOption } from 'main-app/components/FilterControls';

export default (): Array<FilterOption> => [
  {
    label: i18n.t('Customer'),
    name: 'customerIds',
    type: 'customer',
    multi: true,
  },
  {
    label: i18n.t('Status'),
    name: 'statuses',
    type: 'select',
    multi: true,
    selectOptions: [
      { label: i18n.t('Open'), value: 'OPEN' },
      { label: i18n.t('Partially Fulfilled'), value: 'PARTIALLY_FULFILLED' },
      { label: i18n.t('Fulfilled'), value: 'FULFILLED' },
      { label: i18n.t('Closed'), value: 'CLOSED' },
    ],
  },
];
